import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    getAllBuyersAction,
    getAllUsersAction,
    getAUserByTokenAction,
} from '../../../../redux/user/userActions'
import { userTypes } from './../../../../redux/user/userTypes'
export const useGetAllUsers = body => {
    const dispatch = useDispatch()
    const { allUsers, allUsersForPrint, loading, meta } = useSelector(
        state => state.user
    )
    useEffect(() => {
        dispatch({
            type: userTypes.GET_ALL_USERS_START,
        })
        const delayDebounceFn = setTimeout(
            () => {
                dispatch(getAllUsersAction(body))
            },
            body.name === '' ? 0 : 2000
        )

        return () => clearTimeout(delayDebounceFn)
    }, [dispatch, body])
    return { allUsers, allUsersForPrint, loading, meta }
}

export const useGetAllBuyers = id => {
    const dispatch = useDispatch()
    const { allBuyers, loading } = useSelector(state => state.user)
    useEffect(() => {
        dispatch({
            type: userTypes.GET_ALL_BUYERS_START,
        })
        dispatch(getAllBuyersAction(id))
    }, [dispatch])
    return { allBuyers, loading }
}

export const useGetAUserByToken = body => {
    const dispatch = useDispatch()
    const { user, loading } = useSelector(state => state.user)

    useEffect(() => {
        dispatch(getAUserByTokenAction())
    }, [dispatch, body])
    return { user, loading }
}
